// Generated by scripts/generate-seo-content.mts. Do not edit.

import dynamic from "next/dynamic";
import type { ComponentType } from "react";
import type { MDXProps } from "mdx/types";

export const seoContentBySlug: Record<string, ComponentType<MDXProps>> = {
  "ai-assisted-decision-making": dynamic(() => import("../../content/seo/ai-assisted-decision-making.mdx")),
  "ai-brainstorming-tools": dynamic(() => import("../../content/seo/ai-brainstorming-tools.mdx")),
  "boardblend-vs-chatgpt": dynamic(() => import("../../content/seo/boardblend-vs-chatgpt.mdx")),
  "boardblend-vs-figjam": dynamic(() => import("../../content/seo/boardblend-vs-figjam.mdx")),
  "boardblend-vs-lucidspark": dynamic(() => import("../../content/seo/boardblend-vs-lucidspark.mdx")),
  "boardblend-vs-miro": dynamic(() => import("../../content/seo/boardblend-vs-miro.mdx")),
  "boardblend-vs-mural": dynamic(() => import("../../content/seo/boardblend-vs-mural.mdx")),
  "feature-prioritization": dynamic(() => import("../../content/seo/feature-prioritization.mdx")),
  "groupthink-examples": dynamic(() => import("../../content/seo/groupthink-examples.mdx")),
  "how-to-brainstorm-with-ai": dynamic(() => import("../../content/seo/how-to-brainstorm-with-ai.mdx")),
  "miro-alternatives": dynamic(() => import("../../content/seo/miro-alternatives.mdx")),
};
